import { InvoiceImportOutlineIcon } from './InvoiceImportOutlineIcon';

/**
 * author: Jeff Anders
 * id 9B0C48A2-870D-43B1-9F73-57688AA5B888
 * name invoice-import-outline
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/invoice-import-outline.svg
 * tags
 * - Banking 
 * - Shopping 
 */
export const InvoiceInboundOutlineIcon = InvoiceImportOutlineIcon;
export default InvoiceInboundOutlineIcon